export default __webpack_public_path__ + "static/media/jeffrey.410df5ad.png";